import get from 'lodash.get';
import { getFormattedLinks } from 'src/universal/utils/getFormattedLinks';

export const getContentGroup = data => {
  const key = 'prospect';
  const dataLists = get(data, 'summitHeroData.heroContent') || [];
  return dataLists.find(l => l.key === key);
};

export const processSummitHeroData = (summitData, pageEep, eepHash) => {
  const contentResult = [0, 1].map(i => {
    const key = get(summitData, `heroContent[${i}].key`) || '';
    const items = get(summitData, `heroContent[${i}].content`) || [];
    return {
      key,
      content: items.map(item => {
        return {
          ...item,
          links: getFormattedLinks(item.links, pageEep, eepHash, item.shortName)
        };
      })
    };
  });
  return {
    ...summitData,
    heroContent: contentResult
  };
};
